import { applyReducers } from 'redux/helpers';
import * as actions from './actions';
import currentItem from './currentItem/reducer';

export default (previosState = {}, action) => {
  const state = applyReducers({ currentItem }, previosState, action);

  switch (action.type) {
    case actions.INIT.BEGIN:
      return {
        ...state,
        projectId: action.projectId,
      };
    case actions.INIT.END:
      return {
        ...state,
        itemsModel: action.itemsModel,
        itemOptions: action.itemOptions,
        simpleOptions: action.simpleOptions,
        containerOptions: action.containerOptions,
        statusOptions: action.statusOptions,
        colors: action.colors,
        statusBehaviours: action.statusBehaviours,
        itemTypes: action.itemTypes,
        changes: 0,
      };
    case actions.SAVE.BEGIN:
      return {
        ...state,
        saving: true,
      };
    case actions.SAVE.END:
      return {
        ...state,
        saving: false,
      };
    case actions.INVALIDATE:
      return {
        ...state,
        itemOptions: action.itemOptions,
        changes: action.changes,
      };
      case actions.ADD_ITEM.END:
        return {
          ...state,
          itemOptions: action.itemOptions
        };
    case actions.REMOVE.END:
      return {
        ...state,
        itemOptions: action.itemOptions
      };
    case actions.INVALIDATE_SERVER.END:
      return {
        ...state,
        itemsModel: action.itemsModel,
        itemOptions: action.itemOptions,
        statusOptions: action.statusOptions,
        simpleOptions: action.simpleOptions,
        containerOptions: action.containerOptions,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/itemType/reducer.js